import { Tab } from '@mui/material';
import withStyles from '@mui/styles/withStyles';

export default withStyles(theme => ({
  root: {
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(4),
    color: 'rgba(0, 0, 0, 0.4)',
    '&:hover': {
      color: '#000',
      opacity: 1,
    },
    '&$selected': {
      color: '#000',
      fontWeight: 500,
    },
    '&:focus': {
      color: '#000',
    },
  },
  selected: {},
}))(Tab);
